module.exports = __webpack_public_path__ + "img/about-2-2.02336f06.jpeg";